import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]理财首页重构-新猜你想买-冷启动无手机号无客户号
 */
export function coldStartLcHomeUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultLcHomeXCNXMDto> {
  return resource.postNoAuth('/lcHomeReDesign/coldStartLcHome', req, config);
}

/**
 * [No Auth]理财首页重构-热基话题详情页-评论观点
 */
export function commentUsingPOST(req: CommentDto | void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.postNoAuth('/lcHomeReDesign/comment', req, config);
}

/**
 * [No Auth]理财首页重构-热基话题观点-点赞
 */
export function commentLikesUsingPOST(req: TopicParam | void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.postNoAuth('/lcHomeReDesign/commentLikes', req, config);
}

/**
 * [No Auth]理财首页重构-热基话题观点-取消点赞
 */
export function commentUnlikesUsingPOST(req: TopicParam | void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.postNoAuth('/lcHomeReDesign/commentUnlikes', req, config);
}

/**
 * [No Auth]理财首页重构-热基话题详情页-删除观点
 */
export function delCommentUsingPOST(req: CommentDto | void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.postNoAuth('/lcHomeReDesign/delComment', req, config);
}

/**
 * [No Auth]理财-文字跑马灯0理财首页1理财持仓
 */
export function getLcTextUsingPOST_1(
  req: TextTickerParam | void,
  config?: RequestConfig
): Promise<ApiResultListTextTickerDto> {
  return resource.postNoAuth('/lcHomeReDesign/getLcText', req, config);
}

/**
 * [No Auth]理财首页重构-理财聚焦新客理财新发基金
 */
export function getNewModuleUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultListLcColumDto> {
  return resource.postNoAuth('/lcHomeReDesign/getNewModule', req, config);
}

/**
 * [No Auth]理财首页重构-热基话题栏目信息
 */
export function getRJHTInfoUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultLcColumDto> {
  return resource.postNoAuth('/lcHomeReDesign/getRJHTInfo', req, config);
}

/**
 * [No Auth]理财首页重构-热基话题-获取用户点赞点踩以及点赞数点踩数
 */
export function getStatusUsingPOST(
  req: TopicParam | void,
  config?: RequestConfig
): Promise<ApiResultTopicLikesStatusDto> {
  return resource.postNoAuth('/lcHomeReDesign/getStatus', req, config);
}

/**
 * [No Auth]理财首页重构-查询新发基金产品列表
 */
export function getXFJJListUsingPOST(
  req: XfjjParam | void,
  config?: RequestConfig
): Promise<ApiResultListLcHomeFundDto> {
  return resource.postNoAuth('/lcHomeReDesign/getXFJJList', req, config);
}

/**
 * [No Auth]理财首页重构-查询新客理财产品列表
 */
export function getXKLCListUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultListLcHomeFundDto> {
  return resource.postNoAuth('/lcHomeReDesign/getXKLCList', req, config);
}

/**
 * [No Auth]理财首页重构-查询新客理财产品列表-二级页面
 */
export function getXKLCListSecondUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultLcXKLCSecondDto> {
  return resource.postNoAuth('/lcHomeReDesign/getXKLCListSecond', req, config);
}

/**
 * [No Auth]理财首页重构-新猜你想买-有客户号
 */
export function queryByClientIdLcHomeUsingPOST(
  req: HoldRecommendQuery | void,
  config?: RequestConfig
): Promise<ApiResultLcHomeXCNXMDto> {
  return resource.postNoAuth('/lcHomeReDesign/queryByClientIdLcHome', req, config);
}

/**
 * [No Auth]理财首页重构-新猜你想买-有手机号
 */
export function queryByPhoneLcHomeUsingPOST(req: PhoneDto, config?: RequestConfig): Promise<ApiResultLcHomeXCNXMDto> {
  return resource.postNoAuth('/lcHomeReDesign/queryByPhoneLcHome', req, config);
}

/**
 * 理财首页重构-首页-机会清单三种情况
 */
export function queryChanceListHomeUsingPOST(
  req: LcHomeCNXMParam | void,
  config?: RequestConfig
): Promise<ApiResultChanceFundsTab> {
  return resource.post('/lcHomeReDesign/queryChanceListHome', req, config);
}
/**
 * 理财首页重构-首页-机会清单三种情况
 */
export function queryChanceListHomeNoLoginUsingPOST(
  req: LcHomeCNXMParam | void,
  config?: RequestConfig
): Promise<ApiResultChanceFundsTab> {
  return resource.postNoAuth('/lcHomeReDesign/queryChanceListHome', req, config);
}

/**
 * 理财首页重构-二级页面-机会清单三种情况
 */
export function queryChanceListSecondUsingPOST(
  req: LcHomeCNXMParam | void,
  config?: RequestConfig
): Promise<ApiResultChanceFundsTab> {
  return resource.post('/lcHomeReDesign/queryChanceListSecond', req, config);
}
/**
 * 理财首页重构-二级页面-机会清单三种情况
 */
export function queryChanceListSecondNoLoginUsingPOST(
  req: LcHomeCNXMParam | void,
  config?: RequestConfig
): Promise<ApiResultChanceFundsTab> {
  return resource.postNoAuth('/lcHomeReDesign/queryChanceListSecond', req, config);
}

/**
 * [No Auth]理财首页重构-热基话题-二级页面根据话题id查产品
 */
export function queryHotTopicByTopicIdUsingPOST(
  req: TopicParam | void,
  config?: RequestConfig
): Promise<ApiResultHomeTop5TopicDto> {
  return resource.postNoAuth('/lcHomeReDesign/queryHotTopicByTopicId', req, config);
}

/**
 * [No Auth]理财首页重构-热基话题-首页
 */
export function queryHotTopicFirstUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultListHomeTop5TopicDto> {
  return resource.postNoAuth('/lcHomeReDesign/queryHotTopicFirst', req, config);
}

/**
 * [No Auth]理财首页重构-热基话题-详情页优化方案一查询子评论
 */
export function queryHotTopicSecondChildCommentUsingPOST(
  req: TopicParam | void,
  config?: RequestConfig
): Promise<ApiResultListHotTopicCommentDto> {
  return resource.postNoAuth('/lcHomeReDesign/queryHotTopicSecondChildComment', req, config);
}

/**
 * [No Auth]理财首页重构-热基话题-详情页优化方案一查询根评论
 */
export function queryHotTopicSecondRootCommentUsingPOST(
  req: TopicParam | void,
  config?: RequestConfig
): Promise<ApiResultListHotTopicCommentDto> {
  return resource.postNoAuth('/lcHomeReDesign/queryHotTopicSecondRootComment', req, config);
}

/**
 * [No Auth]理财首页重构-新猜你想买栏目信息
 */
export function queryNewModuleInfoUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultLcColumDto> {
  return resource.postNoAuth('/lcHomeReDesign/queryNewModuleInfo', req, config);
}

/**
 * [No Auth]理财首页重构-规模风向标-首页
 */
export function queryScaleFangxiangFirstUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultETFFundsTab> {
  return resource.postNoAuth('/lcHomeReDesign/queryScaleFangxiangFirst', req, config);
}

/**
 * [No Auth]理财首页重构-规模风向标-二级页面
 */
export function queryScaleFangxiangSecondUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultETFFundsTab> {
  return resource.postNoAuth('/lcHomeReDesign/queryScaleFangxiangSecond', req, config);
}

/**
 * 理财首页重构-首页-智能推荐三种情况
 */
export function querySmartRecommendUsingPOST(
  req: LcHomeCNXMParam | void,
  config?: RequestConfig
): Promise<ApiResultListConcernedFund> {
  return resource.post('/lcHomeReDesign/querySmartRecommend', req, config);
}

/**
 * [No Auth]欢聚直播-财福周周看
 */
export function queryTop3CFUsingPOST(
  req: HJLiveListRequestDto | void,
  config?: RequestConfig
): Promise<ApiResultListHJLiveListContentDto> {
  return resource.postNoAuth('/lcHomeReDesign/queryTop3CF', req, config);
}

/**
 * [No Auth]欢聚直播top3列表
 */
export function queryTop3LiveListUsingPOST(
  req: void,
  config?: RequestConfig
): Promise<ApiResultListHJLiveListContentDto> {
  return resource.postNoAuth('/lcHomeReDesign/queryTop3LiveList', req, config);
}

/**
 * [No Auth]test for ids
 */
export function testIdsUsingPOST(req: CommentDto | void, config?: RequestConfig): Promise<ApiResultListint> {
  return resource.postNoAuth('/lcHomeReDesign/testIds', req, config);
}

/**
 * [No Auth]理财首页重构-热基话题-点踩
 */
export function topicDislikesUsingPOST(req: TopicParam | void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.postNoAuth('/lcHomeReDesign/topicDislikes', req, config);
}

/**
 * [No Auth]理财首页重构-热基话题-点赞
 */
export function topicLikesUsingPOST(req: TopicParam | void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.postNoAuth('/lcHomeReDesign/topicLikes', req, config);
}

/**
 * [No Auth]理财首页重构-热基话题-取消点踩
 */
export function topicUnDislikesUsingPOST(req: TopicParam | void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.postNoAuth('/lcHomeReDesign/topicUnDislikes', req, config);
}

/**
 * [No Auth]理财首页重构-热基话题-取消点赞
 */
export function topicUnlikesUsingPOST(req: TopicParam | void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.postNoAuth('/lcHomeReDesign/topicUnlikes', req, config);
}
